export const NANCY_SMITH_ID = '018e2cc9-7488-7e50-8a3a-fd3a6561c01e';
export const HEATHER_THOMAS_ID = '019078e2-4e69-7b8c-a878-889a6b5afbfa';
